import { useContext, useEffect, useState } from "react";
import SiteTypeUI from "./SiteType.presenter";
import { useRouter } from "src/hooks/useRouter";
import { switchPayTypeRoute } from "./switchPayTypeRoute";
import { useRecoilState } from "recoil";
import { navStepAtom, productKeyAtom } from "src/atoms";
import { getMyServiceBill } from "src/service/pay";
import { notifyError, notifySuccess } from "src/components/Common/Toast";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useGetMyServiceList } from "src/hooks/api/product/useGetMyServiceList";
import { usePriceList } from "src/hooks/api/price/usePriceList";
import { getLanguage } from "src/utils/localization";
import { payPlanMapper } from "src/utils/Mapper/payPlanMapper";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
import Footer from "components/Footer";
import { ProductKey } from "src/config/config";
import { useIsCashApply } from "src/hooks/recoil/useIsCashApply";
import { useGetPayUnregisterBill } from "src/hooks/api/bill/useGetPayUnregisterBill";
import { useTranslation } from "react-i18next";
import { ModalsDispatchContext } from "src/context/Modal/Console/ConsoleModal.context";
import { useGetPromotionUnregisterBill } from "src/hooks/api/bill/useGetPromotionUnregisterBill";
import { useIsWrapsodyProduct } from "src/hooks/recoil/useIsWrapsodyProduct";
import { useGetCashStatus } from "src/hooks/api/pay/useGetCashStatus";
import { updateCashStatus } from "src/service/pay";

interface ISiteTypeContainerProps { }

const SiteTypeContainer = () => {
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  const [isShowFooter, setIsShowFooter] = useState<boolean>(false);
  // const [payPlanInfo, setPayPlanInfo] = useRecoilState(payPlanInfoAtom);
  const [payPlanInfo, setPayPlanInfo] = useState<any>();

  const { userCashStatusLoading, userCashStatus, userCashStatusRefetch } =
    useGetCashStatus({ onSuccess: () => { } });

  const [showCashRequestDel, setShowCashRequestDel] = useState<boolean>(false);
  const [deleteCashReqMsg, setDeleteCashReqMsg] = useState<string>("");

  const [payTerm, setPayTerm] = useState<string>("month");
  const [toggleMoreInfoOn, setToggleMoreInfoOn] = useState<boolean>(false);
  const [confirmTrial, setConfirmTrial] = useState<boolean>(false);
  const [confirmBasic, setConfirmBasic] = useState<boolean>(false);
  const [confirmPlus, setConfirmPlus] = useState<boolean>(false);
  const [confirmPromotion, setConfirmPromotion] = useState<boolean>(false);
  const [modal, setModal] = useState({
    confirmNoticePaypal: false,
  });
  const [payUrl, setPayUrl] = useState<string>("");
  const [payType, setPayType] = useState<string>("");
  const [drivePrice, setDrivePrice] = useState({});
  const [basicPrice, setBasicPrice] = useState({});
  const [plusPrice, setPlusPrice] = useState({});
  const [basicPlusPrice, setBasicPlusPrice] = useState({});
  const [plusPlusPrice, setPlusPlusPrice] = useState({});
  // const [payPlanInfo, setPayPlanInfo] = useState();
  // const [priceList, setPriceList] = useState(
  //   PRICE_LIST({ t })
  // );

  const { isOciProduct } = useIsOciProduct();
  const { isWrapsody } = useIsWrapsodyProduct();
  const route = useRouter();
  const { t } = useTranslation();
  const { isPriceListLoading, priceList } = usePriceList({});
  const { isCashApply } = useIsCashApply();
  const { isMyServiceLoading, serviceList } = useGetMyServiceList({});
  const { setShowSiteNewModal, setServiceBillUid } = useContext(
    ModalsDispatchContext
  );
  const { isLoading: unregisterPayLoading, unregisterPayList } =
    useGetPayUnregisterBill({
      onSuccess: (data) => {
        if (data?.length > 0) {
          setServiceBillUid(data?.[0]?.serviceBillUid ?? "");
        }
      },
    });
  const { isLoading: unregisterPromotionLoading, unregisterPromotionList } =
    useGetPromotionUnregisterBill({
      onSuccess: (data) => {
        if (data?.length > 0) {
          setServiceBillUid(data?.[0]?.serviceBillUid ?? "");
        }
      },
    });
  // const { isLoading: unregisterPromotionLoading, unregisterPromotionList } =
  //   useGetPromotionUnregisterBill({});
  // useCheckMyService();

  useEffect(() => {
    async function checkUnregisterBill() {
      if (
        (unregisterPayList && unregisterPayList?.length > 0) ||
        (unregisterPromotionList && unregisterPromotionList?.length > 0)
      ) {
        // console.log("unregisterPayList", unregisterPayList);
        route.goConsole();
      }
      if (serviceList?.length > 0 && (isWrapsody && isOciProduct)) {
        route.goConsole();
      } else if (serviceList?.length > 0 && !isOciProduct) {
        route.goConsole();
      }
      if (isCashApply) {
        // 현금결제 요청 상태인 경우
        // route.goConsole();
      }
    }
    if (!isOciProduct) {
      route.goSitePromotion({});
    } else {
      checkUnregisterBill();
    }
    if (productKey && priceList) {
      switchPayTypeRoute({ payType, route });
      setNavStep(2);
      setProductKey(getProductFromSessionStorage());
      // setProductToSessionStorage("WRPASODY");
      // console.log("getProductInfo.name", getProductInfo().name);

      const result = payPlanMapper({ productKey, priceList });
      // console.log("payPlan result", result);
      setPayPlanInfo({ ...result });
    }
  }, [
    productKey,
    priceList,
    isOciProduct,
    unregisterPayList,
    unregisterPromotionList,
  ]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    switch (e.target?.name) {
      case "deleteCashReqMsg":
        setDeleteCashReqMsg(e.target.value);
        break;
    }
  };

  const showCashReqModal = () => {
    setShowCashRequestDel(true);
  };

  const hideCashReqModal = () => {
    setShowCashRequestDel(false);
  };

  const requestCashStatus = async (status: string) => {
    if (userCashStatus) {
      const param = {
        serviceCashUid: userCashStatus.serviceCashUid,
        status,
        msg: deleteCashReqMsg,
      };
      await updateCashStatus(param).then((res) => {
        if (res.status === "CANCEL") {
          notifySuccess(t("cashStatus.removeSuccess"));
          setDeleteCashReqMsg("");
          userCashStatusRefetch();
          setShowCashRequestDel(false);
        } else if (res.status === "APPLY") {
          notifySuccess(t("cashStatus.requestNotic"));
          userCashStatusRefetch();
          route.goConsole();
        }
      });
    }
  };

  const startPay = async (payType: string) => {
    // console.log("startPAy", payType);
    route.goPay({ pay: payTerm, type: payType });
  };
  const startService = async (serviceType: string) => {
    console.log("serviceType", serviceType);
    // 등록된 서비스가 있는지 찾는다.
    const myServiceBill = await getMyServiceBill({
      product: sessionStorage.getItem("product") as ProductKey,
    });
    let goService = true;
    if (myServiceBill.length > 1) {
      let deleteCount = 0;
      myServiceBill.forEach((bill: any) => {
        if (bill.payStatus === "END") {
          deleteCount++;
        }
      });

      if (myServiceBill.length !== deleteCount + 1) {
        goService = false;
      }
    } else if (myServiceBill.length === 1) {
      myServiceBill.forEach((bill: any) => {
        if (bill.payStatus !== "END") {
          if (
            bill.billType === "PROMOTION" ||
            (bill.billType === "PAY" && bill.status === "LINK")
          ) {
            goService = false;
          }

          if (
            bill.billType === "PAY" &&
            bill.status === "UNLINK" &&
            (serviceType === "TRIAL" || serviceType === "PROMOTION")
          ) {
            goService = false;
          }
        }
      });
    }

    if (goService) {
      switch (serviceType) {
        case "TRIAL":
          // window.location.href = `${process.env.PUBLIC_URL}/${lang}/site/trial`
          route.goSiteTrial();
          break;
        case "DRIVE":
          startPay("drive");
          break;
        case "PAY_B":
          startPay("basic");
          break;
        case "PAY_A":
          startPay("plus");
          break;
        case "PAY_C":
          startPay("basicPlus");
          break;
        case "PAY_D":
          startPay("plusPlus");
          break;
        case "PROMOTION":
          if (myServiceBill.length >= 1) {
            let promotionGo = false;
            let idx = 0;
            let checkIdx = 0;
            myServiceBill.forEach((bill: any) => {
              if (bill.payStatus !== "END") {
                promotionGo = true;
                checkIdx = idx;
              }
              idx++;
            });
            if (promotionGo) {
              route.goSitePromotion({
                renewCode: myServiceBill[checkIdx].serviceBillUid,
              });
            } else {
              if (isOciProduct && productKey === "WRAPSODY_ECO") {
                route.goPay({ pay: payTerm, type: payType });
              } else {
                notifyError(t("subscriptionType.alreadyCreatedMsg"));
              }
            }
          } else {
            route.goSitePromotion({});
          }
          break;
        default:
          startPay(serviceType);
          break;
      }
    } else {
      if (isOciProduct && productKey === "WRAPSODY_ECO") {
        switch (serviceType) {
          case "TRIAL":
            // window.location.href = `${process.env.PUBLIC_URL}/${lang}/site/trial`
            route.goSiteTrial();
            break;
          case "DRIVE":
            startPay("drive");
            break;
          case "PAY_B":
            startPay("basic");
            break;
          case "PAY_A":
            startPay("plus");
            break;
          case "PAY_C":
            startPay("basicPlus");
            break;
          case "PAY_D":
            startPay("plusPlus");
            break;
          case "PROMOTION":
            if (myServiceBill.length >= 1) {
              let promotionGo = false;
              let idx = 0;
              let checkIdx = 0;
              myServiceBill.forEach((bill: any) => {
                if (bill.payStatus !== "END") {
                  promotionGo = true;
                  checkIdx = idx;
                }
                idx++;
              });
              if (promotionGo) {
                route.goSitePromotion({
                  renewCode: myServiceBill[checkIdx].serviceBillUid,
                });
              } else {
                if (isOciProduct && productKey === "WRAPSODY_ECO") {
                  route.goPay({ pay: payTerm, type: payType });
                } else {
                  notifyError(t("subscriptionType.alreadyCreatedMsg"));
                }
              }
            } else {
              route.goSitePromotion({});
            }
            break;
          default:
            startPay(serviceType);
            break;
        }
      } else {
        notifyError(t("subscriptionType.alreadyCreatedMsg"));
      }
    }
  };

  const toggleMoreInfo = () => {
    setToggleMoreInfoOn((prev) => !prev);
  };

  const toggleModalNoticePaypal = (payType: string) => {
    setModal((prev) => ({
      ...prev,
      confirmNoticePaypal: !prev.confirmNoticePaypal,
    })),
      setPayType(payType);
  };

  const checkConfirm = (type: string) => {
    switch (type) {
      case "TRIAL":
        return confirmTrial;
      case "PAY_B":
        return confirmBasic;
      case "PAY_A":
        return confirmPlus;
      case "PROMOTION":
        return confirmPromotion;
      default:
        return confirmPromotion;
    }
  };
  const getProductPrice = (key: string): any => {
    const product = getProductFromSessionStorage();
    const lang = getLanguage();
    // console.log("producty", product);
    // console.log("payPlanInfo", payPlanInfo);
    switch (key) {
      case "free":
        return confirmTrial;
      case "drive":
        // return payPlanInfo[product]["drive"][lang]["year"];
        // return payPlanInfo.WRAPSODY.basic.ko;
        return drivePrice;
      case "basic":
        // return payPlanInfo[product]["basic"][lang]["year"];
        return basicPrice;
      case "basicPlus":
        return basicPlusPrice;
      case "plus":
        return plusPrice;
      case "plusPlus":
        return plusPlusPrice;
      case "premium":
        return confirmPromotion;
      default:
        return confirmPromotion;
    }
  };
  if (isMyServiceLoading && !payPlanInfo) return <></>;
  return (
    <>
      {payPlanInfo && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <SiteTypeUI
            payTerm={payTerm}
            // handleChange={handleChange}
            setIsShowFooter={setIsShowFooter}
            startService={startService}
            toggleMoreInfo={toggleMoreInfo}
            toggleMoreInfoOn={toggleMoreInfoOn}
            confirmTrial={confirmTrial}
            checkConfirm={checkConfirm}
            toggleModalNoticePaypal={toggleModalNoticePaypal}
            modal={modal}
            payType={payType}
            startPay={startPay}
            userCashStatus={userCashStatus}
            payPlanInfo={payPlanInfo}
            isCashApply={isCashApply}
            showCashReqModal={showCashReqModal}
            hideCashReqModal={hideCashReqModal}
            requestCashStatus={requestCashStatus}
            deleteCashReqMsg={deleteCashReqMsg}
            showCashRequestDel={showCashRequestDel}
            handleChange={handleChange}
          />
          {isShowFooter && <Footer />}
        </div>
      )}
    </>
  );
};

export default SiteTypeContainer;
